/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useState} from 'react';
import {GoogleMap, InfoWindow, Marker, useJsApiLoader} from "@react-google-maps/api";
import PetrolStationService from "../../services/petrol-station.service";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
import { IPetrolStation, IStationFeature } from 'models/petrol-station';

interface IMapProps {
    isOpen: boolean;
    containerStyle?: React.CSSProperties;
    center?: boolean;

    mapAction(): void;
}

export function Map(props: IMapProps) {

    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_MAPS_API_KEY || '',
        libraries: ['places']
    })
    
    const checkOpenMain = (props.isOpen === true) ? 'map' : 'd-none';
    const [openMarkers, setOpenMarkers]: [Array<IPetrolStation>, any] = useState([]);
    const [features, setFeatures]: [Array<IStationFeature>, any] = useState([]);
    const [stations, setStations]: [Array<IPetrolStation>, any] = useState([]);
    const [visibleStations, setVisibleStations]: [Array<IPetrolStation>, any] = useState([]);

    const containerStyle = {
        width: '100%',
        height: '72vh'
    };
    const center = {
        lat: 58.694065,
        lng: 25.907626
    };

    const showLabel = (clickedMarkerId: number) => {
        const marker = stations.find(x => x.id === clickedMarkerId);
        if (marker && !openMarkers.find(marker => marker.id === clickedMarkerId)) {
            setOpenMarkers([...openMarkers, marker]);
        }
    };
    const hideLabel = (closedMarkerId: number) => {
        if (openMarkers.find(marker => marker.id === closedMarkerId)) {
            const leftoverMarkers = openMarkers.filter(marker => marker.id !== closedMarkerId);
            setOpenMarkers(leftoverMarkers);
        }
    };
    const isLabelVisible = (station: any): boolean => {
        return !!openMarkers.find(marker => marker.id === station.id);
    };

    useEffect(() => {
        PetrolStationService.getFeatures({ page: 0, size: 999 }).then((response) => {
            const loadedFeatures = [...response.content];
            for (const feature of loadedFeatures) {
                feature.disabled = false;
            }
            setFeatures(loadedFeatures);
        });
        PetrolStationService.getStations({ page: 0, size: 999 }).then((response) => {
            setStations(response.content);
        });

    }, [checkOpenMain]);

    useEffect(() => {
        setVisibleStations(stationsFiltered);
    }, [features]);

    const onFilterChange = (feature: IStationFeature): void => {
        const copy = [...features];
        const changedFeat = copy.find(feat => feat.id === feature.id);
        if (changedFeat)
            changedFeat.enabled = !changedFeat.enabled;
        setFeatures(copy);
    };

    const stationsFiltered = stations.filter((station: IPetrolStation) => {
        const lookingForFeatures = features.filter(feature => feature.enabled === true);
        if (lookingForFeatures.length > 0) {
            let contains = true;
            for (const feature of lookingForFeatures) {
                if (station.enabledFeatures.indexOf(feature.id) === -1) {
                    contains = false;
                }
            }
            return contains;
        } else {
            return true;
        }
    });


    const petrolStations = visibleStations.map((station: IPetrolStation) =>
        <Marker
            key={station.id}
            clickable={true}
            title={station.nameEt}
            onClick={() => showLabel(station.id)}
            icon={{
                url: 'static/media/terminal-logo-pin.ed26a0dc.svg',
                size: {
                    height: 30, width: 25,
                    equals: () => true
                },
                fillColor: '#FF0000',
                fillOpacity: .6,
                strokeColor: "blue",
                scale: 1,
                strokeWeight: 0
            }}
            position={{
                lat: station.latitude || 0,
                lng: station.longitude || 0
            }}>
            {isLabelVisible(station) &&
            <InfoWindow onCloseClick={() => hideLabel(station.id)} position={{ lat: station.latitude || 0, lng: station.longitude || 0 }}>
                <div style={{'color': 'black'}}>
                    {station.nameEt}
                </div>
            </InfoWindow>
            }
        </Marker>
    );

    if (!isLoaded) {
        return null;
    }

    return (
        <div className={checkOpenMain}>
            <div className='d-flex justify-content-between mb-4'>
                <span>
                  Filtreeri tanklaid
                </span>
                <button type='button'
                        className='btn btn-light'
                        onClick={props.mapAction}>
                    <span>Sulge otsing</span>
                    <i className='d-inline-block icon--8 icon__close ml-1'/>
                    <i className='d-none icon--8 map__pin ml-1'/>
                </button>
            </div>
            <div id="station-features" className='d-flex justify-content-center flex-wrap mb-3 mb-sm-5 w-100'>
                {features &&
                features.map((feat) =>
                    <OverlayTrigger key={feat.id} overlay={
                        <Tooltip id={`tooltip-${feat.nameEt}`}>
                            <p style={{margin: '3px'}}>{feat.nameEt}</p>
                        </Tooltip>}
                                    placement={"bottom"}>
                        <div key={feat.code} className={"d-flex flex-column"} onClick={() => onFilterChange(feat)}>
                            {
                                feat &&
                                <div key={feat.code} className={"d-flex map__circle" + (feat.enabled ? '--required ' : '')}>
                                    <i className={"icon--30 mx-2 my-auto " + getIconWithCode(feat.code) + (feat.enabled ? '--required ' : '')}/>
                                </div>
                            }
                        </div>
                    </OverlayTrigger>)
                }
            </div>
            <GoogleMap id="footerMap"
                mapContainerStyle={containerStyle}
                center={center}
                zoom={7}>
                {petrolStations}
            </GoogleMap>
        </div>
    )
}

function getIconWithCode(code: string) {
    switch (code) {
        case "AIR":
            return 'icon__air';
        case "WIFI":
            return 'icon__wifi';
        case "WC":
            return 'icon__toilet';
        case "WATER":
            return 'icon__water';
        case "TRUCK_FUEL":
            return 'icon__truck-fuel';
        case "VACUUM":
            return 'icon__vacuum';
        case "REPAIR":
            return 'icon__repair';
        case "TRUCK_PARKING":
            return 'icon__truck-parking';
        case "STORE":
            return 'icon__store';
        case "BOAT_FUEL":
            return 'icon__boat-fuel';
        case "COFFEE_MACHINE":
            return 'icon__coffee-machine';
        case "CAFETERIA":
            return 'icon__cafeteria';
        case "WINDSCREEN_FLUID":
            return 'icon__windscreen-washing-fluid';
        case "FASTFOOD":
            return 'icon__fastfood';
        case "TRAILER_RENT":
            return 'icon__trailer-rent';
        case "GAS":
            return 'icon__gas';
        case "SHOWER":
            return 'icon__shower';
        case "CAR_WASH":
            return 'icon__car-wash';
        case "ADBLUE":
            return 'icon__adblue-text';
        case "ALWAYS_OPEN":
            return 'icon__always-open';
        case "ELECTRIC_VEHICLE_CHARGER":
            return 'icon__ev-charger';
        case "DKV":
            return 'icon__dkv';
        case "UTA":
            return 'icon__uta';
        case "LPG":
            return 'icon__lpg';
        case "RE_DIESEL":
            return 'icon__re-diesel';  
        default:
            return ''
    }
}